type StringOrNumber = string | number;

export interface MarginProps {
  m?: StringOrNumber;
  mt?: StringOrNumber;
  mr?: StringOrNumber;
  mb?: StringOrNumber;
  ml?: StringOrNumber;
  mx?: StringOrNumber;
  my?: StringOrNumber;
}

export interface PaddingProps {
  p?: StringOrNumber;
  pt?: StringOrNumber;
  pr?: StringOrNumber;
  pb?: StringOrNumber;
  pl?: StringOrNumber;
  px?: StringOrNumber;
  py?: StringOrNumber;
}

const toUnits = (value?: StringOrNumber) =>
  typeof value === 'number' && value !== 0 ? `${value}px` : value;

export const spacing = {
  margin: ({ m, mt, mr, mb, ml, mx, my }: MarginProps) => {
    const top = toUnits(mt ?? my ?? m);
    const right = toUnits(mr ?? mx ?? m);
    const bottom = toUnits(mb ?? my ?? m);
    const left = toUnits(ml ?? mx ?? m);
    return [
      typeof top !== 'undefined' && `margin-top: ${top};`,
      typeof right !== 'undefined' && `margin-right: ${right};`,
      typeof bottom !== 'undefined' && `margin-bottom: ${bottom};`,
      typeof left !== 'undefined' && `margin-left: ${left};`,
    ]
      .filter(Boolean)
      .join('');
  },
  padding: ({ p, pt, pr, pb, pl, px, py }: PaddingProps) => {
    const top = toUnits(pt ?? py ?? p);
    const right = toUnits(pr ?? px ?? p);
    const bottom = toUnits(pb ?? py ?? p);
    const left = toUnits(pl ?? px ?? p);
    return [
      typeof top !== 'undefined' && `padding-top: ${top};`,
      typeof right !== 'undefined' && `padding-right: ${right};`,
      typeof bottom !== 'undefined' && `padding-bottom: ${bottom};`,
      typeof left !== 'undefined' && `padding-left: ${left};`,
    ]
      .filter(Boolean)
      .join('');
  },
};
